import React from 'react';
import './App.css';
import Map from './components/map'

function App() {
  return (
    <div className="App">
      <Map />
    </div>
  );
}

export default App;